import styles from './notification.module.css';

const EmptyNotification = () => {
	return (
		<div className={styles.emptyNotificationContainer}>
			<img
				src="/images/svg/diagonal-bell.svg"
				alt="No notifications"
				className={styles.notificationIcon}
			/>
			<h4 className={styles.notificationTextTitle}>No notifications</h4>
			<p className={styles.notificationTextBody}>Nothing to see here.</p>
		</div>
	);
};

export default EmptyNotification;
